import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
} from 'recharts';

function clampPercent(n: number) {
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(100, n));
}

function formatPercent(value: number, total: number) {
  if (!total) return '0%';
  const pct = (value / total) * 100;
  return `${Math.round(clampPercent(pct))}%`;
}

type PieDatum = {
  name: string;
  value: number;
  color: string;
};

function renderOuterLabel(props: any) {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    outerRadius,
    name,
    value,
    payload,
    percent, // percent do recharts (0..1)
  } = props;

  const p = Math.round((percent || 0) * 100);
  const r = outerRadius + 24;
  const x = cx + r * Math.cos(-midAngle * RADIAN);
  const y = cy + r * Math.sin(-midAngle * RADIAN);

  const fill = payload?.color ?? '#111827';

  return (
    <text
      x={x}
      y={y}
      fill={fill}
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      style={{ fontSize: 14 }}
    >
      {name}: {p}%
    </text>
  );
}

export function DashboardPieCard({
  title,
  data,
}: {
  title: string;
  data: PieDatum[];
}) {
  const visible = data.filter(d => d.value > 0);

  // Se tudo for 0, evita erro e mostra “vazio”
  const safe = visible.length ? visible : [{ name: 'Sem dados', value: 1, color: '#9CA3AF' }];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
        {title}
      </h2>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={safe}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={0}
              outerRadius={72}
              labelLine={false}
              label={renderOuterLabel}
              isAnimationActive={false}
            >
              {safe.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>

            <Legend
              verticalAlign="bottom"
              align="center"
              iconType="square"
              wrapperStyle={{ paddingTop: 12 }}
              formatter={(value: any) => (
                <span className="text-sm text-gray-700 dark:text-gray-300">{value}</span>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default DashboardPieCard
